<template>
  <line-chart
    class="fill-height"
    :raw-data="sortedDiagnosticStats"
    :chart-value-keys="chartValueKeys"
    x-value="key"
    :xaxis="xAxisConfig"
    :yaxis="yAxisConfig"
    :fill="fillConfig"
    :tooltip="tooltipConfig"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <v-row
          align="center"
        >
          <v-col>
            <div class="subtitle-2 grey--text text--grey-100">
              {{ $t('card_title.composite_graph') }}
            </div>
          </v-col>
          <v-col
            v-if="removable"
            cols="auto"
          >
            <v-btn
              icon
              style="pointer-events: auto"
              @click="$emit('remove')"
            >
              <v-icon small>
                fal fa-times
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            v-else
            cols="auto"
          >
            <v-btn-toggle
              v-model="composite"
              mandatory
              color="primary"
            >
              <v-btn
                small
                class="text-none"
                value="composite"
              >
                {{ $t('card.composite_graph.display_option.composite') }}
              </v-btn>
              <v-btn
                small
                class="text-none"
                value="normalized"
              >
                {{ $t('card.composite_graph.display_option.normalized') }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import { sortBy } from 'lodash'

export default {
  name: 'CompositeDiagChart',
  components: { LineChart },
  props: {
    stats: {
      type: [Array, Object],
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    composite: 'composite'
  }),
  computed: {
    sortedDiagnosticStats() {
      if (this.removable) {
        return this.getMockData()
      }

      if (!this.stats || !this.stats.groups) {
        return []
      }

      const statsWithName = this.stats.groups.map(group => {
        return {
          ...group,
          name: this.$t(`diagnostics.groups.${group.group_id}`)
        }
      })
      return sortBy(statsWithName, ['name'])
    },
    chartValueKeys() {
      return [
        {
          key: this.composite === 'composite' ? 'comp_value' : 'norm_comp_value',
          type: 'bar'
        }
      ]
    },
    xAxisConfig() {
      return {
        labels: {
          rotate: -45,
          hideOverlappingLabels: false,
          trim: true
        },
        categories: this.sortedDiagnosticStats.map(group => group.name)
      }
    },
    yAxisConfig() {
      return [
        this.composite === 'composite'
          ? { min: -3, max: 3 }
          : { min: 0, max: 100 }
      ]
    },
    fillConfig() {
      return {
        type: 'solid',
        opacity: [0.5]
      }
    },
    tooltipConfig() {
      return {
        y: {
          title: {
            formatter: () => this.$t('tooltip.value')
          }
        }
      }
    }
  },
  methods: {
    getMockData() {
      const round2 = (num) => Math.round(num * 100) / 100

      return [
        {
          group_id: 'cardiovascular',
          name: 'Cardiovascular',
          comp_value: round2(Math.random() * 4 - 2),
          norm_comp_value: round2(Math.random() * 80 + 20)
        },
        {
          group_id: 'muscular',
          name: 'Muscular Strength',
          comp_value: round2(Math.random() * 4 - 2),
          norm_comp_value: round2(Math.random() * 80 + 20)
        },
        {
          group_id: 'flexibility',
          name: 'Flexibility',
          comp_value: round2(Math.random() * 4 - 2),
          norm_comp_value: round2(Math.random() * 80 + 20)
        },
        {
          group_id: 'balance',
          name: 'Balance',
          comp_value: round2(Math.random() * 4 - 2),
          norm_comp_value: round2(Math.random() * 80 + 20)
        },
        {
          group_id: 'endurance',
          name: 'Endurance',
          comp_value: round2(Math.random() * 4 - 2),
          norm_comp_value: round2(Math.random() * 80 + 20)
        }
      ]
    }
  }
}
</script>
